<div class="main-font">
  <div
    class="card-container"
    [ngStyle]="{ width: widthColumn + 'px' }"
    [@slideUp]="animationState"
    (@slideUp.done)="onAnimationDone($event)">
    <div class="w-100 pe-2">
      <div class="d-flex justify-content-end">
        <button class="transparent-btn" (click)="onOverlayClick()">
          <img src="assets/images/icon_calendar/close-modal.svg" alt="close" />
        </button>
      </div>
      <div
        class="calendar-container month-picker position-relative"
        [attr.data-label]="formattedMonth">
        <button
          class="transparent-btn prev position-absolute"
          [ngStyle]="{ left: notifications?.weeks.length > 0 ? '18%' : '23%' }"
          (click)="previousMonth()">
          <img src="assets/images/icon_calendar/previews.svg" alt="previews" />
          <div
            class="prev__badge"
            *ngIf="notifications?.months?.previus?.total > 0">
            {{ notifications?.months?.previus?.total }}
          </div>
        </button>
        <nz-date-picker
          #datePicker
          nzMode="week"
          class="w-100"
          nzInline
          [(ngModel)]="monthSelected"
          (ngModelChange)="changeRange()"
          [nzShowToday]="false"></nz-date-picker>
        <div *ngIf="notifications?.weeks.length > 0" class="badge-container">
          <ng-container *ngFor="let notification of notifications?.weeks">
            <button
              class="btn-badge"
              (click)="
                filterCalendarForUsersNotification(
                  notification.usersId,
                  notification.startWeek
                )
              "
              [disabled]="notification.counter === 0"
              [class]="{
                transparent: notification.counter === 0
              }">
              {{ notification.counter }}
            </button>
          </ng-container>
        </div>
        <button
          class="transparent-btn next position-absolute"
          [ngStyle]="{ left: notifications?.weeks.length > 0 ? '65%' : '75%' }"
          (click)="nextMonth()">
          <img src="assets/images/icon_calendar/next.svg" alt="next" />
          <div
            class="next__badge"
            *ngIf="notifications?.months?.next?.total > 0">
            {{ notifications?.months?.next?.total }}
          </div>
        </button>
      </div>
    </div>

    <div *ngIf="eventsSelected.length" class="event-badge">
      {{ eventsSelected.length }} Filtri eventi attivi
    </div>
    <div class="filter-container my-scrollbar pe-2">
      <div class="toggle-container">
        <div
          class="event-container"
          *ngFor="let event of events; let first = first; let last = last">
          <div class="d-flex align-items-center gap-2">
            <img [src]="event.img" [alt]="event.label" class="icon-event" />
            <p class="text-event mb-0">{{ event.label }}</p>
          </div>
          <div class="d-flex align-items-center gap-3">
            <button
              class="transparent-btn"
              *ngIf="last && userRole != 'admin'"
              (click)="openModalDesiredSmart()">
              <img
                src="assets/images/icon_calendar/smart_settings.svg"
                alt="setting" />
            </button>
            <nz-switch
              nzSize="small"
              [(ngModel)]="event.value"
              (ngModelChange)="onEventSelected()"></nz-switch>
          </div>
        </div>
      </div>
      <nz-collapse
        class="collapse-container"
        nzGhost
        [nzExpandIconPosition]="'right'">
        <nz-collapse-panel [nzHeader]="teamTemplate" class="w-100">
          <div class="my-scrollbar content-team">
            <nz-checkbox-group
              [(ngModel)]="teams"
              (ngModelChange)="onTeamSelected()"></nz-checkbox-group>
          </div>
        </nz-collapse-panel>
        <ng-template #teamTemplate>
          <div class="d-flex align-items-center gap-2">
            <img
              src="assets/images/icon_calendar/team.svg"
              alt="team"
              class="team-icon" />
            <p class="mb-0 text-collapse">Team</p>
            <div *ngIf="teamsSelected.length > 0" class="badge-filter">
              {{ teamsSelected.length }}
            </div>
          </div>
        </ng-template>
        <nz-collapse-panel [nzHeader]="roleTemplate" class="w-100">
          <div class="my-scrollbar content-team">
            <nz-checkbox-group
              [(ngModel)]="roles"
              (ngModelChange)="onRoleSelected()"></nz-checkbox-group>
          </div>
        </nz-collapse-panel>
        <ng-template #roleTemplate>
          <div class="d-flex align-items-center gap-2">
            <img
              src="assets/images/icon_calendar/role.svg"
              alt="role"
              class="role-icon" />
            <p class="mb-0 text-collapse">Ruolo</p>
            <div *ngIf="rolesSelected.length > 0" class="badge-filter">
              {{ rolesSelected.length }}
            </div>
          </div>
        </ng-template>
      </nz-collapse>
    </div>
  </div>
</div>
